import { render, staticRenderFns } from "./Orden01Configura.vue?vue&type=template&id=3b4874ac&"
import script from "./Orden01Configura.vue?vue&type=script&lang=js&"
export * from "./Orden01Configura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports